import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Toolbar,
  Typography,
} from '@mui/material';
import { Field, DebouncedTextField } from '../fields';

export default function SaveDialog({ onClose, onSave, ...other }) {
  return (
    <Dialog onClose={onClose} {...other}>
      <AppBar position="static">
        <Toolbar variant="dense" sx={{ pl: 2 }}>
          <Typography variant="h6" color="inherit">
            Save As
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent sx={{ pt: 2 }}>
        <DialogContentText>
          Please give this retrospective a name
        </DialogContentText>
        <Field
          autoFocus
          margin="dense"
          fullWidth
          label="Title"
          name="title"
          component={DebouncedTextField}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onSave} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
